/** Shared helpers for CCS Spotlight. */

export const CATEGORY_STYLES = {
  "Customer Service": "bg-[#C28A2E]/10 text-[#9A6B1E]",
  Leadership: "bg-[#5D3A1F]/10 text-[#5D3A1F]",
  Communication: "bg-[#B7541E]/10 text-[#B7541E]",
  Collaboration: "bg-[#2A1810]/10 text-[#2A1810]",
  "Emotional Intelligence": "bg-[#C28A2E]/20 text-[#5D3A1F]",
  Teamwork: "bg-[#B7541E]/20 text-[#7A3E15]",
};

export const CATEGORIES = Object.keys(CATEGORY_STYLES);

export const categoryBadge = (category) =>
  CATEGORY_STYLES[category] || "bg-[#2A1810]/10 text-[#2A1810]";

export const formatSpotlightDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return "";
  }
};

export const spotlightUrl = (id) => `${window.location.origin}/spotlight/${id}`;

export const shareLinks = (spotlight) => {
  const url = encodeURIComponent(spotlightUrl(spotlight.id));
  const title = encodeURIComponent(
    `CCS Spotlight — ${spotlight.title || spotlight.honoree_name}`
  );
  return {
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    email: `mailto:?subject=${title}&body=${encodeURIComponent(
      `I thought you'd enjoy this CCS Spotlight story:\n\n${spotlightUrl(spotlight.id)}`
    )}`,
  };
};
